/**
 * Legacy-Redirect: /premium → /plans — Story 0.2 (v2-Relaunch)
 *
 * Die Tarif-Seite heisst im finalen Design "Plans" und liegt unter /plans.
 * Vorher war das eine Lazy-Route (_auth.premium.lazy.tsx); ein Redirect
 * braucht keinen Lazy-Chunk mehr.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/premium')({
  beforeLoad: () => {
    throw redirect({ to: '/plans', replace: true })
  },
  component: () => null,
})
